module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_6_1.3e47140c.jpeg";